package learning.components


import antd.card.card
import antd.message.message
import antd.tabs.tabPane
import antd.tabs.tabs
import com.jingfangpai.api.clients.AcupointApiClient
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.content.model.ContentQuery
import com.jingfangpai.content.model.ContentVo
import kotlinext.js.jsObject
import kotlinx.browser.window
import kotlinx.html.js.onClickFunction
import kotlinx.html.unsafe
import react.*
import react.dom.a
import react.dom.attrs
import react.dom.div
import react.dom.h3
import react.router.dom.useHistory
import learning.containers.MeridiansPageContext
import react.dom.jsStyle
import urlBase

external interface MeridiansProps : RProps {

}

data class MeridiansContextData(var placeHolderFunction: (param: String) -> Unit)

val Meridians = functionalComponent<MeridiansProps> { props ->

    val ctx = useContext(MeridiansPageContext)
    val (query,setQuery) = useState(ContentQuery().apply {
        type = ContentType.Meridian
    })
    val history = useHistory()
    val (meridians,setMeridians) = useState(arrayOf<ContentVo>())
    val (clickCount,setClickCount) = useState(0)
    val (acupoints,setAcupoints) = useState(arrayOf<Pair<String,String>>()) // id to name mapping
    val (selectedMeridianId, setSelectedMeridianId) = useState<String?>(null)

    useEffectOnce {
        ctx.query(query,{ resp ->
            if(resp.ok()){
                val data = resp.data?:arrayOf()
                setMeridians(data)
                // Set first meridian as selected by default
                if (data.isNotEmpty()) {
                    setSelectedMeridianId(data[0].id)
                }
            }else{
                message.error("获取经络出错：${resp.message}")
            }
        },{
            message.error("获取经络出错：${it.message}")
        })
        
        // Fetch acupoint list for matching
        try {
            AcupointApiClient.listIdAndName({ resp ->
                if(resp.ok() && resp.data != null) {
                    setAcupoints(resp.data!!.map { it.id!! to it.name!! }.toTypedArray())
                    console.log("Loaded ${resp.data!!.size} acupoints")
                } else {
                    console.warn("Failed to load acupoints: ${resp.message}")
                }
            }, { error ->
                console.error("Exception loading acupoints:", error)
                // Don't block the page if acupoints fail to load
            })
        } catch (e: Exception) {
            console.error("Error calling AcupointApiClient:", e)
        }
    }
    
    // Function to find acupoints in content
    fun findAcupointsInContent(content: String?): List<Pair<String, String>> {
        if (content.isNullOrBlank()) return emptyList()
        
        val foundAcupoints = mutableListOf<Pair<String, String>>()
        acupoints.forEach { (id, name) ->
            if (content.contains(name)) {
                foundAcupoints.add(id to name)
            }
        }
        return foundAcupoints.distinctBy { it.second } // Remove duplicates by name
    }

    div("Meridians") {

        card {
            attrs {
                title = "十四经络"
                extra = buildElement {
                    if (!selectedMeridianId.isNullOrBlank()) {
                        a {
                            this.attrs {
                                target = "_blank"
                                href = "${urlBase}/learning/meridian/edit/${selectedMeridianId}"
                                style = kotlinext.js.js {
                                    marginRight = "8px"
                                }
                            }
                            +"编辑"
                        }
                    }
                    a {
                        this.attrs {
                            target = "_blank"
                            href = "${urlBase}/learning/meridian/edit/new"
                        }
                        +"添加"
                    }
                }
            }
            div("card-container") {
                tabs {
                    attrs {
                        type = "card"
                        onChange = { key->
                            setSelectedMeridianId(key.toString())
                            setClickCount(clickCount+1)
                            /*if(clickCount%9 == 0){
                                setClickCount(0)
                                history.push("${urlBase}/study/meridian/edit/${key}")
                            }*/
                        }
                    }

                    meridians.forEachIndexed {index, meridian ->
                        tabPane {
                            attrs {
                                tab = buildElement {
                                    div {
                                        attrs.jsStyle = jsObject {
                                            display = "flex"
                                            alignItems = "center"
                                            gap = "8px"
                                        }
                                        +"${meridian.title}"
                                    }
                                }
                                key = "${meridian.id}"
                            }
                            div {
                                attrs.jsStyle = jsObject {
                                    display = "flex"
                                    gap = "24px"
                                    minHeight = "200px"
                                }
                                
                                // Left: Content
                                div {
                                    attrs.jsStyle = jsObject {
                                        flex = 1
                                    }
                                    attrs.unsafe {
                                        +"${meridian.content}"
                                    }
                                }
                                
                                // Right: Acupoint index bar
                                div {
                                    attrs.jsStyle = jsObject {
                                        width = "200px"
                                        borderLeft = "1px solid #f0f0f0"
                                        paddingLeft = "16px"
                                    }
                                    
                                    h3 {
                                        attrs.jsStyle = jsObject {
                                            fontSize = "14px"
                                            fontWeight = "600"
                                            marginBottom = "12px"
                                            color = "rgba(0, 0, 0, 0.85)"
                                        }
                                        +"📍 相关穴位"
                                    }
                                    
                                    val matchedAcupoints = findAcupointsInContent(meridian.content)
                                    
                                    if (matchedAcupoints.isNotEmpty()) {
                                        div {
                                            attrs.jsStyle = jsObject {
                                                display = "flex"
                                                flexDirection = "column"
                                                gap = "8px"
                                            }
                                            
                                            matchedAcupoints.forEach { (id, name) ->
                                                a {
                                                    attrs.href = "#"
                                                    attrs.jsStyle = jsObject {
                                                        padding = "6px 12px"
                                                        fontSize = "13px"
                                                        color = "#1890ff"
                                                        textDecoration = "none"
                                                        borderRadius = "4px"
                                                        backgroundColor = "#e6f7ff"
                                                        transition = "all 0.3s"
                                                        cursor = "pointer"
                                                    }
                                                    attrs.onClickFunction = { event ->
                                                        event.preventDefault()
                                                        window.open("${urlBase}/learning/acupoint/detail/$id", "_blank")
                                                    }
                                                    +"$name →"
                                                }
                                            }
                                        }
                                    } else {
                                        div {
                                            attrs.jsStyle = jsObject {
                                                fontSize = "13px"
                                                color = "#999"
                                                fontStyle = "italic"
                                            }
                                            +"暂无匹配穴位"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
